/**
 * 연계정보 수집기록·취급대장 (/adm/ci/collect-log?tab=collect|use)
 * ($j.Pages.Admin.CiCollectLog / body data-page-name="CiCollectLog")
 *
 * 탭은 서버가 가른다(주소의 tab) — 이 모듈은 그 탭의 표 하나만 띄운다.
 */
export default class CiCollectLog {
    initialize() { initialize(); }
}

let TAB = 'collect';
let PROVIDER = '';   // 제공기관은 하나뿐이라 컬럼이 아니라 상수다
let $table = null, $useTable = null;

function initialize() {
    const d = JSON.parse(document.getElementById('page-data').textContent);
    TAB = d.tab;
    PROVIDER = d.provider;

    TAB === 'use' ? loadUseTable() : loadTable();

    $('#u-search').on('click', function(){ $useTable && $useTable.ajax.reload(); });
    $('#u-reset').on('click', function(){
        $('#u-from, #u-to, #u-target').val('');
        $('#u-action, #u-purpose, #u-channel, #u-actor').val('');
        $useTable && $useTable.ajax.reload();
    });
    $('#u-target').on('keydown', function(e){ if (e.key === 'Enter') $('#u-search').click(); });

    $('#btn-search').on('click', function(){ $table && $table.ajax.reload(); });
    $('#btn-reset').on('click', function(){
        $('#f-from, #f-to, #f-target').val('');
        $('#f-purpose, #f-dev').val('');
        $table && $table.ajax.reload();
    });
    // 수집대상 입력창에서 엔터로도 조회
    $('#f-target').on('keydown', function(e){ if (e.key === 'Enter') $('#btn-search').click(); });
}

function loadTable() {
    const columns = [
        { data: 'num', title: '번호', width: '70px', className: 'text-center' },
        // 제공기관명 + 인증수단
        { data: null, title: '제공기관명', width: '150px', className: 'text-center',
            render: function (d, t, r) {
                const dev = r.dev_str ? `<span class="ci-mbno">${r.dev_str}</span>` : '';
                return `${PROVIDER} ${dev}`;
            }
        },
        { data: null, title: '수집목적', width: '110px', className: 'text-center',
            render: (d, t, r) => `<span class="ci-purpose ci-purpose-${r.purpose_key}">${r.purpose_str || ''}</span>`
        },
        // 수집대상 — 회원일련번호 / 아이디 (CI 제외)
        { data: null, title: '수집대상 회원일련번호', width: '150px', className: 'text-center',
            render: (d, t, r) => r.mb_no
                ? $j.F.Admin.Member.Pop.cellNo(r.mb_no)
                : '<span class="ci-none">-</span>'
        },
        { data: null, title: '수집대상 아이디',
            render: (d, t, r) => r.mem_id
                ? `<span class="ci-memid">${r.mem_id}</span>`
                : '<span class="ci-none">-</span>'
        },
        { data: 'datetime', title: '제공일시', width: '160px', className: 'text-center',
            render: v => v ? $j.Common.Util.formatDateTime(v) : '<span class="ci-none">-</span>'
        },
    ];

    if ($table) {
        $table.destroy();
        $('#ci-table').empty();
    }

    $table = new DataTable('#ci-table', {
        autoWidth: false,
        columns: columns,
        headerCallback: (thead) => $(thead).find('th').css('text-align', 'center'),
        ajax: {
            url: '/adm/ajax/ci/collect-log/list',
            type: 'post',
            data: function (d) {
                d.from    = $('#f-from').val();
                d.to      = $('#f-to').val();
                d.purpose = $('#f-purpose').val();
                d.dev     = $('#f-dev').val();
                d.target  = $('#f-target').val();
            },
            dataSrc: function (json) {
                $('#f-count').text(json.recordsFiltered ?? 0);
                return json.data;
            },
        },
        language: {
            emptyTable: "수집기록이 없습니다.",
            info: "", infoEmpty: "", infoFiltered: "",
            loadingRecords: "로딩 중...",
            zeroRecords: "일치하는 결과가 없습니다.",
            paginate: {
                previous: "<i class='fa fa-chevron-left'></i>",
                next: "<i class='fa fa-chevron-right'></i>"
            }
        },
        processing: true,
        serverSide: true,
        ordering: false,
        pageLength: 25,
        lengthChange: false,
        searching: false
    });
}

function loadUseTable() {
    const columns = [
        { data: 'num', title: '번호', width: '70px', className: 'text-center' },
        { data: null, title: '구분', width: '80px', className: 'text-center',
            render: (d, t, r) => `<span class="ci-act ci-act-${r.action}">${r.action_str || ''}</span>`
        },
        { data: 'purpose_str', title: '이용목적', width: '130px', className: 'text-center' },
        { data: 'channel_str', title: '경로', width: '150px', className: 'text-center' },
        // 대상 — CI 값이 아니라 회원일련번호/아이디만
        { data: null, title: '대상 회원', width: '150px', className: 'text-center',
            render: function (d, t, r) {
                if (!r.mb_no) return '<span class="ci-none">-</span>';
                return $j.F.Admin.Member.Pop.cellNo(r.mb_no)
                     + (r.mem_id ? `<span class="ci-mbno">${r.mem_id}</span>` : '');
            }
        },
        // 어느 수집건에서 나온 이용인가
        { data: null, title: '연관 수집기록', width: '150px', className: 'text-center',
            render: function (d, t, r) {
                if (!r.collect_num) return '<span class="ci-none">-</span>';
                const dev = r.collect_dev ? ` · ${r.collect_dev}` : '';
                return `#${r.collect_num}<span class="ci-link">${dev}</span>`;
            }
        },
        { data: null, title: '처리주체', width: '110px', className: 'text-center',
            render: (d, t, r) => r.actor_type === 'admin'
                ? `관리자<span class="ci-actor-admin">#${r.actor_no || ''}</span>`
                : '회원 본인'
        },
        { data: 'ip', title: 'IP', width: '120px', className: 'text-center',
            render: v => v || '<span class="ci-none">-</span>'
        },
        { data: 'datetime', title: '이용일시', width: '160px', className: 'text-center',
            render: v => v ? $j.Common.Util.formatDateTime(v) : '<span class="ci-none">-</span>'
        },
    ];

    $useTable = new DataTable('#use-table', {
        autoWidth: false,
        columns: columns,
        headerCallback: (thead) => $(thead).find('th').css('text-align', 'center'),
        ajax: {
            url: '/adm/ajax/ci/use-log/list',
            type: 'post',
            data: function (d) {
                d.from        = $('#u-from').val();
                d.to          = $('#u-to').val();
                d.action      = $('#u-action').val();
                d.use_purpose = $('#u-purpose').val();
                d.channel     = $('#u-channel').val();
                d.actor       = $('#u-actor').val();
                d.target      = $('#u-target').val();
            },
            dataSrc: function (json) {
                $('#u-count').text(json.recordsFiltered ?? 0);
                return json.data;
            },
        },
        language: {
            emptyTable: "취급기록이 없습니다.",
            info: "", infoEmpty: "", infoFiltered: "",
            loadingRecords: "로딩 중...",
            zeroRecords: "일치하는 결과가 없습니다.",
            paginate: {
                previous: "<i class='fa fa-chevron-left'></i>",
                next: "<i class='fa fa-chevron-right'></i>"
            }
        },
        processing: true,
        serverSide: true,
        ordering: false,
        pageLength: 25,
        lengthChange: false,
        searching: false
    });
}
